import { http } from "../utils/http-common";
import { WorkflowStage } from "../interfaces/WorkflowInterface";

export function getWorkflowStages() {
  return http
    .get("/workflowStages")
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      console.log(err);
    });
}

export async function getSingleWorkflowStage(id: number, parameters?: string) {
  if (!parameters) parameters = "with=orderItems,orderItems.order&limit=500";
  return http.get(`/workflowStages/${id}?${parameters}`).then((res) => {
    return res.data.data;
  });
}
export async function getSingleWorkflowStagePaginated(id: number, parameters?: string) {
  if (!parameters) parameters = "with=orderItems,orderItems.order&limit=500";
  return http.get(`/workflowStages/${id}?${parameters}`).then((res) => {
    return res.data.data;
  });
}

export function deleteWorkflowStage(workflowStageId: number) {
  return http.delete(`/workflowStages/${workflowStageId}`);
}
export async function createWorkflowStage(workflowStage: WorkflowStage) {
  return http.post(`/workflowStages`, workflowStage).then((res) => {
    return res.data.data;
  });
}

export function editWorkflowStage(workflowStage: WorkflowStage): Promise<WorkflowStage> {
  return http.put(`/workflowStages/${workflowStage.id}`, workflowStage).then((res) => {
    return res.data.data;
  });
}
